<template>
  <v-img src="@/assets/logo.png" :max-width="maxWidth" />
</template>

<script>
export default {
  props: ['maxWidth']
}
</script>
